import React from "react";
import Dashboard from "../components/specific/Dashboard";
import Layout from "../components/layout/Layout";

const DashboardPage = () => {
  return (
    <Layout>
      <div className="pt-16 ml-64">
        <Dashboard />
      </div>
    </Layout>
  );
};

export default DashboardPage;
